import React from 'react';
import { connect, useSelector } from 'react-redux';
import EmeraldModal from 'src/common/components/emerald-modal/emerald-modal';
import {
  popEmeraldModal,
  pushEmeraldModal,
} from 'src/common/emerald-modal-manager/emerald-modal-manager';
import {
  ITransactionSearchState,
  TransactionSearchContext,
} from 'src/common/interfaces/states/ITransactionSearchState';
import { AppState } from 'src/common/redux/configure-store';
import { TransactionSearchActions } from 'src/common/redux/reducers/transaction-search-reducer';
import { ScannedDataHandler } from 'src/devices/scanner-operations';
import ParameterSearchScreen from './components/search-by-parameter-screen';
import { ReturnPolicyResponse } from './interfaces/get-effective-return-policy-response';
import TransactionSearchResultsScreen from './transaction-search-results-screen';
import { transactionSearchModalStyles } from './transaction-based-return-styles';

const modalId = 'SearchModal';
type Props = typeof mapDispatchToProps & ITransactionSearchState & ISearchModalProps;

export const showSearchModal = (props: ISearchModalProps, onScan: ScannedDataHandler): void => {
  pushEmeraldModal(<SearchModal {...props} />, onScan, modalId);
};

export const closeSearchModal = (): void => popEmeraldModal(modalId);
const SearchModalScreenLayout = (props: Props): JSX.Element => {
  const classes = transactionSearchModalStyles();
  const trainingModeActive = useSelector((state: AppState): boolean => state.posMode.trainingMode);
  const hideMaxPolicyButton =
    props.returnPolicy && !(props.searchContext === TransactionSearchContext.ReprintReceipt)
      ? false
      : true;

  const {
    dateRange,
    posNumber,
    transactionList,
    transactionNumber,
    storeNumber,
    isSearchResultView,
    setSearchParam,
    customerId,
    pageNumber,
  } = props;

  const renderLayout = (): JSX.Element =>
    isSearchResultView ? (
      <TransactionSearchResultsScreen
        effectivePolicy={props.returnPolicy}
        setSearchParam={setSearchParam}
        onSearch={props.onSearch}
        searchTrasactionResponse={
          transactionList || { pageContent: [], totalResults: 0, totalPages: 0 }
        }
        backToPreviousPage={() => props.onBack(true, !!customerId)}
        pageNumber={pageNumber ?? 0}
        onCancel={props.onCancel}
        onSubmit={props.onSubmit}
        testIdPrefix={'transaction-search-results'}
        searchContext={props.searchContext}
      />
    ) : (
      <ParameterSearchScreen
        dateRange={dateRange}
        storeNumber={storeNumber}
        posNumber={posNumber}
        transactionNumber={transactionNumber}
        setSearchParam={setSearchParam}
        effectivePolicy={props.returnPolicy}
        onSearch={() => props.onSearch('')}
        onCancel={props.onCancel}
        onBack={() => props.onBack(false)}
        testIdPrefix={'transaction-search'}
        hidePolicyMaxButton={hideMaxPolicyButton}
      />
    );

  return (
    <EmeraldModal
      open
      classes={{
        paper: trainingModeActive ? classes.trainingModeBackground : classes.dialogPaper,
      }}
    >
      {renderLayout()}
    </EmeraldModal>
  );
};

const mapStateToProps = (state: AppState): ITransactionSearchState => ({
  dateRange: state.transactionSearch.dateRange,
  posNumber: state.transactionSearch.posNumber,
  storeNumber: state.transactionSearch.storeNumber,
  transactionNumber: state.transactionSearch.transactionNumber,
  transactionList: state.transactionSearch.transactionList,
  isSearchResultView: state.transactionSearch.isSearchResultView,
  customerId: state.transactionSearch.customerId,
  pageNumber: state.transactionSearch.pageNumber,
  itemCode: state.transactionSearch.itemCode,
  searchContext: state.transactionSearch.searchContext,
});

const mapDispatchToProps = {
  setSearchParam: TransactionSearchActions.setSearchParam,
};

const SearchModal = connect(mapStateToProps, mapDispatchToProps)(SearchModalScreenLayout);
export default SearchModal;

export interface ISearchModalProps {
  returnPolicy?: ReturnPolicyResponse;
  onCancel: () => void;
  onSearch: (itemCode?: string | undefined) => Promise<void>;
  onBack: (isResultView: boolean, hasCustomer?: boolean) => void;
  onSubmit: (tlogId: string) => Promise<void>;
  searchContext?: TransactionSearchContext;
}
